import { render, staticRenderFns } from "./RealizaVoto.vue?vue&type=template&id=6bb5d3b1&scoped=true"
import script from "./RealizaVoto.vue?vue&type=script&lang=js"
export * from "./RealizaVoto.vue?vue&type=script&lang=js"
import style0 from "./RealizaVoto.vue?vue&type=style&index=0&id=6bb5d3b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5d3b1",
  null
  
)

export default component.exports